import {Directive, HostListener} from '@angular/core';

/**
 * Selects all text content when the input element receives focus.
 *
 * Usage:
 * ```html
 * <input type="text" appSelectOnFocus />
 * ```
 *
 * This is useful for numeric inputs or fields where users typically
 * want to replace the entire value rather than edit it.
 */
@Directive({
  selector: '[appSelectOnFocus]',
  standalone: false,
})
export class SelectOnFocusDirective {

  /**
   * Handles the focus event and selects all text in the input element.
   * @param event The focus event triggered when the element receives focus
   */
  @HostListener('focus', ['$event'])
  onFocus(event: FocusEvent): void {
    const target = event.target as HTMLInputElement;
    if (target && typeof target.select === 'function') {
      target.select();
    }
  }
}
